export default __webpack_public_path__ + "static/media/leverage.cb3f9e5b.svg";